
import React, { useState, useEffect, useRef } from 'react';
import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import Typography from '@mui/material/Typography';
import { UrlsUtils } from '../../utils/UrlsUtils';
import { useFormik } from 'formik';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  minWidth: 720,
  bgcolor: 'background.paper',
  borderRadius: '6px',
  border: '1px solid #fff',
  boxShadow: 24,
  p: 2,
  textAlign: 'center'
};

export default function CategoryHeader({ onUpdate, index, widget }) {

  const imgBkRef = useRef();
  const dataDefault = {
    text: '',
    color: '',
    image_bk_url: '',
  };
  const isInModification = widget[0]?.data && (Object.keys(widget[0]?.data)?.length > 0);

  //Mui Modal
  const [openModal, setOpenModal] = useState(false);
  const handleOpen = () => setOpenModal(true);
  //const handleClose = () => setOpenModal(false);

  useEffect(() => {
    handleOpen();
    //console.log('CategoryHeader in modifica: ', isInModification)
  }, []);

  //Formik
  const formik = useFormik({
    //initialValues: widget ? widget : dataDefault,
    initialValues: isInModification ? widget[0].data : dataDefault,
    enableReinitialize: true,
    onSubmit: values => {
      alert(JSON.stringify(values, null, 2));
    },
  });

  //Gestione chiusura del modal
  function handleClose(event, reason) {
    //console.log(event, reason);
    switch (reason) {
      case 'backdropClick':
        return;
      case 'escapeKeyDown':
        return;
      default:
        setOpenModal(false);
    }
  }

  function imgError(image) {
    image.onError = "";
    image.src = "/img/logo-startupitalia-rocket.png";
    return true;
  }

  /* useEffect(() => {
      console.log(formik)
  }, [formik.values]); */

  return (
    <>
      <Modal
        aria-labelledby="ch-modal-title"
        aria-describedby="ch-modal-description"
        open={openModal}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      //disableEscapeKeyDown={true} 
      >
        <Fade in={openModal}>
          <Box sx={style}>
            <Typography id="ch-modal-title" variant="h6" component="h2"
              style={{ marginBottom: "20px" }}>
              {isInModification ? 'Category Header' : 'New Category Header'}
            </Typography>
            <div className="row" style={{ display: "flex", textAlign: "left" }}>
              <div className="col-12 p-3">
                <span className="fw-bold">
                  <FontAwesomeIcon icon={['fas', 'asterisk']} size={'1x'} color={'red'} />
                  &nbsp;Title:</span>

                <input type="text" id="text" className="form-control" style={{ width: "100%" }}
                  onChange={formik.handleChange}
                  value={formik.values?.text}
                />
              </div>
            </div>
            <div className="row" style={{ minHeight: "106px", display: "flex", textAlign: "left" }}>
              <div className="col-9 p-3">
                <span className="fw-bold">Color:</span>
                <input type="text" id="color" className="form-control" style={{ width: "100%" }}
                  onChange={formik.handleChange}
                  value={formik.values?.color}
                />
              </div>
              <div className="col-3 text-center align-self-center" >
                {formik.values?.color ?
                  <div style={{
                    minHeight: "1rem", padding: "0px", margin: "0px 28px -10px 28px",
                    boxShadow: "0px 0px 5px 0px #6c757d", backgroundColor: formik.values?.color
                  }}></div>
                  :
                  <img src="/img/logo-startupitalia-rocket.png"
                    className="img-thumbnail mt-3" alt='Thumbnail url'
                    style={{ maxHeight: "5rem", padding: "0px", border: "0px", boxShadow: "0px 0px 5px 0px #6c757d" }}>
                  </img>
                }
              </div>
            </div>

            <div className="row" style={{ minHeight: "106px", display: "flex", textAlign: "left" }}>
              <div className="col-9 mt-3">
                <span className="fw-bold">Image Background URL:</span>
                <input type="text" id="image_bk_url" className="form-control" style={{ width: "100%" }}
                  onChange={formik.handleChange}
                  value={formik.values?.image_bk_url}
                />
              </div>
              <div className="col-3 text-center align-self-center" >
                <a type="button" href={UrlsUtils.recognizingUrl(formik.values?.image_bk_url) ? formik.values?.image_bk_url : null}
                  className="my-tooltip" title="Visualizza immagine" target="_blank" rel="noopener noreferrer">
                  <img src={formik.values?.image_bk_url && formik.values?.image_bk_url} ref={imgBkRef}
                    className="img-thumbnail mt-3" alt='Thumbnail url' onError={() => imgError(imgBkRef.current)}
                    style={{ maxHeight: "5rem", padding: "0px", border: "0px", boxShadow: "0px 0px 5px 0px #6c757d", backgroundColor: "whitesmoke" }}></img>
                </a>
              </div>
            </div>

            <div className='justify-content-center p-5'>
              Compila i campi dell'intestazione
            </div>
            <div className="row">
              <div className="col-12 col-md-6 col-lg-6 col-xl-6">
                <button type="button" className="btn btn-secondary"
                  style={{ minWidth: '6rem', marginLeft: '10px', float: "left" }}
                  onClick={() => { ((widget[0]?.data && isInModification) ? onUpdate(null, -1) : onUpdate(null, index)); handleClose(); }}>
                  Chiudi
                </button>
              </div>
              <div className="col-12 col-md-6 col-lg-6 col-xl-6" style={{ display: "contents" }}>
                <span style={{ color: "red", float: "right", margin: "16px 10px 0px 0px" }}>
                  <FontAwesomeIcon icon={['fas', 'asterisk']} size={'1x'} color={'red'} />
                  <span className="user-select-none">Indica un campo obbligatorio</span>
                </span>
                {formik.values?.text?.length ?
                  <button type="button" className="btn btn-success"
                    style={{ minWidth: '6rem', marginRight: '10px', float: "right" }}
                    onClick={() => { onUpdate(formik.values, index); handleClose(); }}>
                    Conferma
                  </button>
                  : ''}
              </div>
            </div>
          </Box>
        </Fade>
      </Modal>
    </>
  );
}